import moment from "moment";

// Demo-only WhatsApp inbox: canned conversations plus a tiny scripted
// "assistant" so the simulator can show the AI-first, human-handover flow
// without Meta or an AI account. Nothing here is real or stored.

export const CLINIC = "Apollo Clinic, Ulubari";

export const DOCTORS = [
  { id: "d1", name: "Dr Akhil Ch Sarma", dept: "General Medicine", fee: 600 },
  { id: "d2", name: "Dr Abhisekh Agarwal", dept: "Orthopaedics", fee: 800 },
  { id: "d3", name: "Dr Amrita Pincha", dept: "Dermatology", fee: 700 },
  { id: "d4", name: "Dr Rakesh Periwal", dept: "Cardiology", fee: 900 },
];

export const STAFF = ["Neha Das", "Priyanka Bora", "Rahul Kalita"];

// Sample answers for the demo — the real clinic fills in its own.
const K = (id, topic, keywords, answer) => ({ id, topic, keywords, answer });
export const DEFAULT_KB = [
  // Appointments
  K("k1", "How to book", ["how to book", "how do i book", "appointment kaise"], "You can book right here on WhatsApp — just tell me the doctor or department and the day, e.g. \"skin doctor tomorrow\". You can also call 0361-2460000 or walk in to the front desk."),
  K("k2", "Walk-in", ["walk in", "walk-in", "without appointment", "direct come", "token"], "Walk-ins are welcome, but patients with appointments are seen first. Booking on WhatsApp takes a minute and saves you the wait."),
  K("k3", "Waiting time", ["waiting", "wait time", "how long", "running late", "delay"], "Waiting is usually under 20 minutes for booked patients. If your doctor is running late, we message you on WhatsApp before you leave home."),
  K("k4", "Booking for family", ["my mother", "my father", "my child", "my son", "my daughter", "my wife", "my husband", "family", "for someone else"], "Yes, you can book for family members on your number. Just tell me their name and age when booking."),
  K("k5", "Doctor on leave", ["on leave", "leave", "not coming", "absent", "back when"], "If a doctor is on leave we inform booked patients on WhatsApp and offer another day or doctor. Tell me the doctor's name and I'll check their next available day."),
  // Fees & payment
  K("k6", "Consultation fees", ["fee", "fees", "charge", "consultation", "kitna"], "Consultation fees: General Medicine ₹600, Dermatology ₹700, Orthopaedics ₹800, Cardiology ₹900."),
  K("k7", "Follow-up", ["follow up", "follow-up", "followup", "revisit", "second visit"], "A follow-up with the same doctor within 7 days is free. After 7 days the normal fee applies."),
  K("k8", "Payment modes", ["upi", "card", "cash", "gpay", "phonepe", "paytm", "payment"], "We accept cash, UPI (GPay, PhonePe, Paytm) and all debit/credit cards."),
  K("k9", "Insurance", ["insurance", "cashless", "mediclaim", "tpa", "reimbursement"], "Cashless is available for diagnostics with Star Health, HDFC Ergo and Care Health. For other insurers we give a detailed bill and reports for reimbursement."),
  K("k10", "Bill / receipt", ["bill", "receipt", "invoice", "gst"], "Every payment gets a printed bill, and we can send it on WhatsApp too. Ask at the desk for a duplicate anytime."),
  K("k11", "Senior citizen discount", ["senior", "discount", "offer", "concession"], "Senior citizens (60+) get 10% off on lab tests. This month's offer: Full Body Checkup at ₹1,999 instead of ₹2,999."),
  // Timings & location
  K("k12", "Timings", ["timing", "timings", "open", "close", "hours", "sunday"], "We are open Monday to Saturday, 9:00 AM to 7:00 PM. Sunday OPD is 10:00 AM to 1:00 PM. Sample collection starts at 7:00 AM."),
  K("k13", "Holidays", ["holiday", "diwali", "puja", "bihu", "festival", "closed on"], "We stay open on most holidays with shorter hours. On Bihu and Diwali we're open 10 AM to 1 PM. We announce holiday timings on WhatsApp in advance."),
  K("k14", "Location", ["where", "address", "location", "direction", "map", "kaha"], "Apollo Clinic, GS Road, Ulubari, Guwahati 781007 — opposite the Ulubari flyover. Google Maps: https://maps.google.com/?q=Apollo+Clinic+Ulubari"),
  K("k15", "Parking", ["parking", "park", "car"], "Yes, free parking is available in the basement for patients."),
  K("k16", "Wheelchair access", ["wheelchair", "lift", "elevator", "stairs", "disabled"], "Yes, we have a lift and a wheelchair at the entrance. Tell the guard and they'll help you in."),
  // Diagnostics
  K("k17", "Test prices", ["price of", "test price", "cbc", "thyroid", "sugar", "lipid", "vitamin", "hba1c", "lft", "kft", "rate"], "Common test prices: CBC ₹350, Thyroid (T3 T4 TSH) ₹600, Fasting Sugar ₹100, HbA1c ₹550, Lipid Profile ₹650, Vitamin D ₹1,400, LFT ₹750, KFT ₹700."),
  K("k18", "Fasting", ["fasting", "fast", "empty stomach", "khali pet"], "For fasting tests (sugar, lipid profile, LFT) please don't eat for 10–12 hours. Water is fine. Take regular medicines unless your doctor said otherwise."),
  K("k19", "Home collection", ["home collection", "home sample", "collect from home", "ghar", "home visit"], "Yes, we collect samples at home anywhere in Guwahati, 7 AM to 11 AM. Free for orders above ₹999, otherwise ₹150."),
  K("k20", "Report time", ["report", "result", "when will"], "Most blood reports are ready the same evening, X-ray within 4 hours, ultrasound the same day, MRI and CT the next day. We send them to you on WhatsApp."),
  K("k21", "Scans available", ["x-ray", "xray", "ultrasound", "usg", "mri", "ct scan", "ecg", "echo", "tmt"], "We do X-ray, ultrasound (USG), MRI, CT, ECG, 2D Echo and TMT in-house. Most scans can be done the same day — tell me which one and I'll check the slot."),
  K("k22", "Prescription needed", ["prescription needed", "without prescription", "need prescription", "doctor slip"], "Routine blood tests don't need a prescription. MRI, CT and some scans need a doctor's prescription — you can also consult our doctor first."),
  // Packages
  K("k23", "Health packages", ["package", "checkup", "check up", "full body", "health check"], "Packages: Basic Health ₹999 (30 tests), Full Body ₹1,999 (70+ tests), Diabetes Care ₹1,499, Heart Care ₹2,499, Women's Wellness ₹2,299, Senior Citizen ₹2,799. Home collection is free on all packages."),
  K("k24", "Full body tests", ["included", "what tests", "which tests", "contains"], "Full Body Checkup (₹1,999) includes CBC, LFT, KFT, Lipid Profile, Thyroid, HbA1c, Fasting Sugar, Vitamin D, B12, Iron, Urine Routine and more — 70+ parameters."),
  // Before / after visit
  K("k25", "What to bring", ["bring", "documents", "carry", "id proof", "old reports"], "Please bring any old prescriptions and reports, a list of medicines you take, and an ID. Arrive 15 minutes before your slot."),
  K("k26", "Lost prescription", ["lost", "copy of prescription", "lost prescription", "prescription copy", "send prescription", "old prescription"], "No problem — we keep a copy of every prescription. Tell me the doctor and visit date and our team will send it to you on WhatsApp."),
  // Services
  K("k27", "Pharmacy", ["pharmacy", "medical store", "chemist", "dawai"], "Yes, there's a pharmacy on the ground floor, open 8 AM to 9 PM."),
  K("k28", "Other services", ["dentist", "dental", "physio", "physiotherapy", "dietitian", "diet"], "We have Dental, Physiotherapy and a Dietitian on weekdays. Tell me which one and I'll check the next free slot."),
  K("k29", "Vaccination", ["vaccine", "vaccination", "injection", "tika"], "We give vaccinations for children (as per IAP schedule) and adults (flu, hepatitis B, HPV, tetanus). Please bring the vaccination card."),
  K("k30", "Video consultation", ["video consultation", "video", "online consult", "teleconsult", "call consult"], "Yes, video consultations are available with most of our doctors. The fee is the same as an in-clinic visit and the link comes on WhatsApp."),
];

const EMERGENCY = ["chest pain", "breath", "unconscious", "bleeding", "accident", "stroke", "fainted", "seizure", "emergency"];
const MEDICAL = ["should i take", "medicine", "tablet", "dose", "symptom", "is it serious", "what does my report", "normal or not", "fever for", "pain in"];
const HUMAN = ["talk to", "human", "person", "call me", "agent", "manager", "staff"];
const COMPLAINT = [
  "worst", "complain", "refund", "rude", "angry", "pathetic", "disappoint", "bad experience", "bad service", "very bad",
  "poor", "terrible", "horrible", "unhappy", "not happy", "not satisfied", "waste", "useless", "cheat", "overcharg",
  "misbehav", "irresponsible", "never coming", "bekar", "ghatiya", "kharab",
];
const RESCHEDULE = ["reschedule", "change", "shift", "postpone", "another date", "another day", "different time", "other doctor", "another doctor"];
const CANCEL = ["cancel"];
const BOOK = ["book", "appointment", "slot"];

const has = (text, words) => words.some((w) => text.includes(w));

// Typos are normal on WhatsApp ("picha" for "Pincha") — one edit is close enough.
const nearly = (a, b) => {
  if (a === b) return true;
  if (Math.abs(a.length - b.length) > 1 || a.length < 4) return false;
  const dp = Array.from({ length: a.length + 1 }, (_, i) => [i, ...Array(b.length).fill(0)]);
  for (let j = 1; j <= b.length; j++) dp[0][j] = j;
  for (let i = 1; i <= a.length; i++)
    for (let j = 1; j <= b.length; j++)
      dp[i][j] = Math.min(dp[i - 1][j] + 1, dp[i][j - 1] + 1, dp[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
  return dp[a.length][b.length] <= 1;
};

const DEPT_WORDS = {
  d1: ["general", "physician", "fever", "medicine doctor"],
  d2: ["ortho", "bone", "knee", "joint", "back pain doctor"],
  d3: ["skin", "derma", "acne", "hair"],
  d4: ["heart", "cardio", "bp doctor"],
};

const findDoctor = (text) => {
  const words = text.split(/[^a-z]+/).filter(Boolean);
  return DOCTORS.find((d) => {
    const parts = d.name.toLowerCase().split(" ").filter((w) => w.length > 2 && w !== "dr");
    return parts.some((p) => words.some((w) => nearly(w, p))) || DEPT_WORDS[d.id].some((w) => text.includes(w));
  });
};

const WEEKDAYS = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
const findDay = (text) => {
  if (text.includes("today") || text.includes("aaj")) return 0;
  if (text.includes("day after")) return 2;
  if (text.includes("tomorrow") || text.includes("tmrw") || /\bkal\b/.test(text)) return 1;
  const w = WEEKDAYS.findIndex((d) => text.includes(d) || text.includes(d.slice(0, 3) + " "));
  if (w >= 0) return ((w - moment().day() + 7) % 7) || 7;
  return null;
};

export const slotsFor = (dayOffset) => {
  const base = ["09:30 AM", "10:00 AM", "10:30 AM", "11:30 AM", "12:00 PM", "04:00 PM", "04:30 PM", "05:30 PM"];
  // A couple "taken" per day so lists look real.
  return base.filter((_, i) => (i + dayOffset) % 4 !== 1);
};
export const dayLabel = (offset) => moment().add(offset, "days").format("ddd, D MMM");

const at = (minsAgo) => moment().subtract(minsAgo, "minutes").toISOString();

// ---------------------------------------------------------------- the bot

/**
 * One scripted assistant turn. `state` carries the reschedule flow between
 * messages; returns { replies, state, handover? }. Each reply is a message
 * object (text, optional buttons/list) from "ai".
 */
export function botReply(input, state, kb, ctx) {
  const text = input.trim().toLowerCase();
  const ai = (body, extra = {}) => ({ from: "ai", text: body, at: new Date().toISOString(), ...extra });
  const appt = ctx.appointment;

  if (has(text, EMERGENCY)) {
    return {
      state: {},
      replies: [ai("This sounds urgent. Please call 108 right now or come to the nearest emergency. I have alerted our team and someone will call you immediately.")],
      handover: { reason: "Emergency words", priority: "urgent", summary: `Possible emergency: "${input.trim()}"` },
    };
  }

  // --- reschedule flow steps (button / list replies arrive as their ids)
  if (state.flow === "reschedule") {
    if (state.step === "what") {
      if (text === "change_date" || text.includes("date") || text.includes("day")) {
        return {
          state: { flow: "reschedule", step: "pick_day", doctor: appt.doctor },
          replies: [ai(`Sure. Which day would you like with ${appt.doctor.name}?`, {
            list: { button: "Choose a day", rows: [1, 2, 3, 4, 5].map((d) => ({ id: `day_${d}`, title: dayLabel(d), description: `${slotsFor(d).length} slots free` })) },
          })],
        };
      }
      if (text === "change_doctor" || text.includes("doctor")) {
        const others = DOCTORS.filter((d) => d.id !== appt.doctor.id);
        return {
          state: { flow: "reschedule", step: "pick_doctor" },
          replies: [ai("Which doctor would you like to see instead?", {
            list: { button: "Choose a doctor", rows: others.map((d) => ({ id: `doc_${d.id}`, title: d.name, description: `${d.dept} · ₹${d.fee}` })) },
          })],
        };
      }
      // default: time on the same day
      return {
        state: { flow: "reschedule", step: "pick_slot", doctor: appt.doctor, day: appt.dayOffset },
        replies: [ai(`Here are the free times on ${dayLabel(appt.dayOffset)} with ${appt.doctor.name}:`, {
          list: { button: "Choose a time", rows: slotsFor(appt.dayOffset).map((s) => ({ id: `slot_${appt.dayOffset}_${s}`, title: s })) },
        })],
      };
    }
    if (state.step === "pick_doctor" && text.startsWith("doc_")) {
      const doctor = DOCTORS.find((d) => `doc_${d.id}` === text);
      return {
        state: { flow: "reschedule", step: "pick_day", doctor, mode: state.mode },
        replies: [ai(`${doctor.name} (${doctor.dept}). Which day suits you?`, {
          list: { button: "Choose a day", rows: [1, 2, 3, 4, 5].map((d) => ({ id: `day_${d}`, title: dayLabel(d), description: `${slotsFor(d).length} slots free` })) },
        })],
      };
    }
    if (state.step === "pick_day" && text.startsWith("day_")) {
      const day = Number(text.split("_")[1]);
      return {
        state: { ...state, step: "pick_slot", day },
        replies: [ai(`Free times on ${dayLabel(day)} with ${state.doctor.name}:`, {
          list: { button: "Choose a time", rows: slotsFor(day).map((s) => ({ id: `slot_${day}_${s}`, title: s })) },
        })],
      };
    }
    if (state.step === "pick_slot" && text.startsWith("slot_")) {
      const [, day, time] = input.trim().split("_");
      const doctor = state.doctor || appt.doctor;
      return {
        state: {},
        booked: { doctor, dayOffset: Number(day), time, isNew: !appt || state.mode === "new" },
        replies: [ai(
          `✅ ${appt && state.mode !== "new" ? "Done! Your appointment is moved." : "Booked!"}\n\n👨‍⚕️ ${doctor.name}\n📅 ${dayLabel(Number(day))}\n🕐 ${time}\n📍 ${CLINIC}\n\n${appt && state.mode !== "new" ? `Your old slot (${dayLabel(appt.dayOffset)}, ${appt.time}) has been released. ` : ""}Please arrive 15 minutes early.`,
          { buttons: [{ id: "reschedule", title: "Reschedule" }, { id: "cancel", title: "Cancel" }] }
        )],
      };
    }
  }

  if (state.flow === "cancel") {
    if (text === "yes_cancel") {
      return {
        state: {},
        cancelled: true,
        replies: [ai("Your appointment has been cancelled. Would you like to book another time?", { buttons: [{ id: "book_again", title: "Book again" }, { id: "no_thanks", title: "No, thanks" }] })],
      };
    }
    if (text === "keep" && appt) return { state: {}, replies: [ai(`No problem — your appointment on ${dayLabel(appt.dayOffset)} at ${appt.time} stays as it is.`)] };
  }

  if (text === "reschedule" || (appt && has(text, RESCHEDULE))) {
    if (!appt) return { state: {}, replies: [ai("I couldn't find an upcoming appointment on this number. Would you like to book one?")] };
    return {
      state: { flow: "reschedule", step: "what" },
      replies: [ai(`Your appointment: ${appt.doctor.name}, ${dayLabel(appt.dayOffset)} at ${appt.time}.\n\nWhat would you like to change?`, {
        buttons: [{ id: "change_time", title: "Time" }, { id: "change_date", title: "Date" }, { id: "change_doctor", title: "Doctor" }],
      })],
    };
  }

  if (appt && (text === "cancel" || has(text, CANCEL))) {
    return {
      state: { flow: "cancel" },
      replies: [ai(`Cancel your appointment with ${appt.doctor.name} on ${dayLabel(appt.dayOffset)} at ${appt.time}?`, {
        buttons: [{ id: "yes_cancel", title: "Yes, cancel" }, { id: "keep", title: "Keep it" }],
      })],
    };
  }

  if (has(text.replace(/[^a-z ]+/g, " ").replace(/\s+/g, " "), COMPLAINT)) {
    return {
      state: {},
      replies: [ai("I'm really sorry about this. I've passed it to our front-desk manager, who will call you shortly.")],
      handover: { reason: "Complaint", priority: "high", summary: `Complaint: "${input.trim()}"` },
    };
  }
  if (has(text, HUMAN)) {
    return {
      state: {},
      replies: [ai("Of course. I've asked a team member to call you — usually within 10 minutes during clinic hours.")],
      handover: { reason: "Asked for a person", priority: "high", summary: "Patient asked to speak to a person" },
    };
  }
  if (has(text, MEDICAL)) {
    return {
      state: {},
      replies: [ai("I can't give medical advice on chat, but I can book you with the right doctor, or ask our team to call you. A team member will call you shortly.")],
      handover: { reason: "Medical question", priority: "high", summary: `Medical question: "${input.trim()}"` },
    };
  }

  // "Which doctors do you have?" / "what departments?"
  const words = text.split(/[^a-z]+/).filter(Boolean);
  const fuzzy = (list) => list.some((k) => words.some((w) => nearly(w, k)));
  const doctor = findDoctor(text);
  // Best entry = the most keyword hits. Single words must start a word
  // ("eat" shouldn't match "treatment"); typos count as a weaker hit.
  const score = (k) =>
    k.keywords.reduce((sum, raw) => {
      const w = raw.toLowerCase();
      if (w.includes(" ") || /[^a-z]/.test(w)) return sum + (text.includes(w) ? 2 : 0);
      if (words.some((x) => x.startsWith(w))) return sum + 2;
      if (words.some((x) => nearly(x, w) || nearly(x.replace(/s$/, ""), w))) return sum + 1;
      return sum;
    }, 0);
  const ranked = kb.map((k) => ({ k, s: score(k) })).filter((r) => r.s > 0).sort((a, b) => b.s - a.s);
  const hit = ranked[0]?.k;
  // A clear Knowledge Base match beats the generic "list doctors / book" replies.
  if (!doctor && hit && ranked[0].s >= 2) return { state: {}, replies: [ai(hit.answer)], kbHit: hit.topic };
  if (!doctor && (fuzzy(["doctors", "departments", "department", "specialists", "specialities", "specialties"]) || text.includes("which doctor"))) {
    return {
      state: { flow: "reschedule", step: "pick_doctor", mode: "new" },
      replies: [ai(
        `Our doctors at ${CLINIC}:\n\n` +
          DOCTORS.map((d) => `👨‍⚕️ ${d.name} — ${d.dept} (₹${d.fee})`).join("\n") +
          "\n\nOPD runs Monday to Saturday, 9 AM–7 PM. Tap below to see a doctor's free slots.",
        { list: { button: "Choose a doctor", rows: DOCTORS.map((d) => ({ id: `doc_${d.id}`, title: d.name, description: `${d.dept} · ₹${d.fee}` })) } }
      )],
    };
  }

  // "Is Dr Amrita available tomorrow?" / "skin doctor on Monday?"
  if (doctor) {
    const day = findDay(text) ?? 1;
    const slots = slotsFor(day);
    return {
      state: { flow: "reschedule", step: "pick_slot", doctor, day, mode: "new" },
      replies: [ai(`Yes, ${doctor.name} (${doctor.dept}, ₹${doctor.fee}) is available on ${dayLabel(day)} — ${slots.length} slots free. Tap a time to book:`, {
        list: { button: "Choose a time", rows: slots.map((s) => ({ id: `slot_${day}_${s}`, title: s })) },
      })],
    };
  }

  if (text === "book_again" || has(text, BOOK)) {
    return {
      state: { flow: "reschedule", step: "pick_doctor", mode: "new" },
      replies: [ai("Happy to help you book. Which doctor would you like to see?", {
        list: { button: "Choose a doctor", rows: DOCTORS.map((d) => ({ id: `doc_${d.id}`, title: d.name, description: `${d.dept} · ₹${d.fee}` })) },
      })],
    };
  }

  if (hit) return { state: {}, replies: [ai(hit.answer)], kbHit: hit.topic };

  if (["hi", "hello", "hey", "namaskar", "namaste"].some((g) => text.startsWith(g))) {
    return {
      state: {},
      replies: [ai(`Namaskar 🙏 Welcome to ${CLINIC}. I'm the clinic's virtual assistant — I can book or change appointments, share timings and prices, and check reports. How can I help?`, {
        buttons: [{ id: "book_again", title: "Book appointment" }, { id: "reschedule", title: "Change booking" }, { id: "talk to staff", title: "Talk to staff" }],
      })],
    };
  }

  if (["no_thanks", "thank", "thanks", "ok", "okay", "fine", "great", "dhanyavad"].some((w) => text === w || text.startsWith(w))) {
    return { state: {}, replies: [ai("You're welcome! Message us anytime. Take care 🙏")] };
  }

  // Unknown → honest handover, never a guess.
  return {
    state: {},
    replies: [ai("I'm not sure about that one, so I've asked a team member to reply. They'll get back to you shortly.")],
    handover: { reason: "AI not confident", priority: "normal", summary: `Unanswered: "${input.trim()}"` },
  };
}

// ------------------------------------------------------- canned inbox data

const p = (minsAgo, text, extra) => ({ from: "patient", text, at: at(minsAgo), ...extra });
const a = (minsAgo, text, extra) => ({ from: "ai", text, at: at(minsAgo), ...extra });
const s = (minsAgo, by, text) => ({ from: "staff", by, text, at: at(minsAgo) });
const ev = (minsAgo, text) => ({ from: "event", text, at: at(minsAgo) });
const confirmation = (minsAgo, doctor, day, time) =>
  a(minsAgo, `Hello! Your appointment is confirmed ✅\n\n👨‍⚕️ ${doctor}\n📅 ${dayLabel(day)}\n🕐 ${time}\n📍 ${CLINIC}\n\nPlease arrive 15 minutes early with any previous prescriptions.`, {
    template: true,
    buttons: [{ id: "reschedule", title: "Reschedule" }, { id: "cancel", title: "Cancel" }],
  });

export function generateDemoChats() {
  return [
    {
      id: "c1", name: "Bornali Gogoi", phone: "9864012345", owner: "ai", status: "open", unread: 0,
      appointment: { doctor: DOCTORS[2], dayOffset: 1, time: "10:30 AM" },
      lead: "Appointment booked", summary: "Rescheduled dermatology visit by herself using buttons",
      messages: [
        confirmation(180, DOCTORS[2].name, 1, "11:30 AM"),
        p(42, "Reschedule", { tapped: true }),
        a(42, `Your appointment: ${DOCTORS[2].name}, ${dayLabel(1)} at 11:30 AM.\n\nWhat would you like to change?`, { buttons: [{ id: "change_time", title: "Time" }, { id: "change_date", title: "Date" }, { id: "change_doctor", title: "Doctor" }] }),
        p(41, "Time", { tapped: true }),
        a(41, `Here are the free times on ${dayLabel(1)} with ${DOCTORS[2].name}:`, { list: { button: "Choose a time", rows: slotsFor(1).map((t) => ({ id: t, title: t })) } }),
        p(40, "10:30 AM", { tapped: true }),
        a(40, `✅ Done! Your appointment is moved.\n\n👨‍⚕️ ${DOCTORS[2].name}\n📅 ${dayLabel(1)}\n🕐 10:30 AM\n📍 ${CLINIC}\n\nYour old slot (11:30 AM) has been released.`),
        ev(40, "Appointment rescheduled by patient on WhatsApp · 11:30 AM → 10:30 AM"),
      ],
    },
    {
      id: "c2", name: "Rahul Kalita", phone: "7002123456", owner: "human", status: "needs_human", priority: "high", unread: 2,
      handover: { reason: "Medical question", at: at(6) }, summary: "Asking whether to continue BP tablets before the echo test",
      appointment: { doctor: DOCTORS[3], dayOffset: 2, time: "04:00 PM" }, lead: "Appointment booked",
      messages: [
        confirmation(300, DOCTORS[3].name, 2, "04:00 PM"),
        p(7, "Should I take my BP medicine before the 2D echo test?"),
        a(6, "I can't give medical advice on chat, but I've asked our team to help. A team member will call you shortly."),
        ev(6, "Handed over to staff · Medical question"),
        p(3, "ok please call soon"),
      ],
    },
    {
      id: "c3", name: "Glow_with_Rimi", phone: "8011987654", owner: "ai", status: "open", unread: 0, lead: "New lead (Instagram)",
      summary: "Asked about acne treatment price and booked with Dr Pincha",
      appointment: { doctor: DOCTORS[2], dayOffset: 3, time: "05:30 PM" },
      messages: [
        p(95, "hi saw your insta ad for acne treatment. price?"),
        a(95, "Hello! Dermatology consultation with Dr Amrita Pincha is ₹700. The doctor will suggest the treatment plan and its cost after examining. Would you like to book?", { buttons: [{ id: "book", title: "Book now" }, { id: "later", title: "Later" }] }),
        p(93, "Book now", { tapped: true }),
        a(93, "Which day suits you?", { list: { button: "Choose a day", rows: [1, 2, 3].map((d) => ({ id: d, title: dayLabel(d) })) } }),
        p(92, dayLabel(3), { tapped: true }),
        p(91, "05:30 PM", { tapped: true }),
        a(91, `✅ Booked! Dr Amrita Pincha, ${dayLabel(3)} at 05:30 PM. See you soon.`),
        ev(91, "Lead converted → appointment booked by AI"),
      ],
    },
    {
      id: "c4", name: "Deepjyoti Saikia", phone: "9435011223", owner: "human", status: "needs_human", priority: "urgent", unread: 1,
      handover: { reason: "Emergency words", at: at(2) }, summary: "Father has chest pain — told to call 108",
      messages: [
        p(3, "my father having chest pain since morning what to do"),
        a(2, "This sounds urgent. Please call 108 right now or come to the nearest emergency. I have alerted our team and someone will call you immediately."),
        ev(2, "URGENT handover · Emergency words · duty phone alerted"),
      ],
    },
    {
      id: "c5", name: "Juri Baruah", phone: "6000456789", owner: "ai", status: "closed", unread: 0, lead: "Converted",
      summary: "Report ready — sent on WhatsApp",
      messages: [
        p(1500, "is my blood test report ready? booking LAB-261024-0012"),
        a(1499, "Your CBC and Lipid Profile reports are ready. Sending them now 📄"),
        a(1499, "📄 Juri Baruah - CBC.pdf", { document: true }),
        a(1499, "📄 Juri Baruah - Lipid Profile.pdf", { document: true }),
        p(1490, "thank you 🙏"),
        a(1490, "You're welcome! Please share the reports with your doctor. Take care."),
      ],
    },
    {
      id: "c6", name: "Manash Deka", phone: "9101345678", owner: "human", status: "open", unread: 0, assignee: "Priyanka Bora",
      summary: "Package discount for 2 people — staff handling",
      messages: [
        p(220, "full body checkup for 2 people any discount?"),
        a(220, "Full Body Checkup is ₹1,999 per person (70+ tests). For group discounts, let me connect you with our team."),
        ev(219, "Handed over to staff · AI not confident (discount request)"),
        s(205, "Priyanka Bora", "Hi Manash, for 2 people we can do ₹3,600 total with free home collection. Shall I book for Sunday 7 AM?"),
        p(200, "yes sunday is fine"),
        s(198, "Priyanka Bora", "Booked ✅ Our phlebotomist will reach by 7 AM. Please stay fasting from 9 PM Saturday."),
      ],
    },
    {
      id: "c7", name: "Nilakshi Hazarika", phone: "8724012345", owner: "ai", status: "open", unread: 0, lead: "New lead (JustDial)",
      summary: "Asked timings and parking (Assamese)",
      messages: [
        p(60, "Sunday-t clinic khula thake ne?"),
        a(60, "Hoi, Deobar 10:00 AM-ra 1:00 PM loike OPD khula thake. Diagnostics puwa 7:00 bajat khule. Appointment book koribo bisarise ne?"),
        p(58, "parking ase ne?"),
        a(58, "Ase, basement-t parking-r byabostha ase 🚗"),
      ],
    },
    {
      id: "c8", name: "Imran Ahmed", phone: "9706098765", owner: "human", status: "needs_human", priority: "high", unread: 1,
      handover: { reason: "Complaint", at: at(25) }, summary: "Unhappy about 45 min wait yesterday",
      messages: [
        p(26, "worst experience yesterday waited 45 min for doctor"),
        a(25, "I'm really sorry about this. I've passed it to our front-desk manager, who will call you shortly."),
        ev(25, "Handed over to staff · Complaint"),
      ],
    },
  ];
}
